<template>
  <div>
    <address class="mb-4">
      <span
        v-if="address.attributes.address_line_1"
        v-text="address.attributes.address_line_1"
      />
      <br v-if="address.attributes.address_line_1">
      <span
        v-if="address.attributes.address_line_2"
        v-text="address.attributes.address_line_2"
      />
      <br v-if="address.attributes.address_line_2">
      <span
        v-if="address.attributes.city"
        v-text="`${address.attributes.city},`"
      />
      <span
        v-if="address.attributes.region"
        v-text="`${address.attributes.region} `"
      />
      <span
        v-if="address.attributes.postal_code"
        v-text="address.attributes.postal_code"
      />
      {{ $root.Union.enable_international_formatting ? `, ${address.attributes.country}` : '' }}
    </address>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'Address',
  props: {
    address: {
      type: Object,
      required: true,
    },
  },
}
</script>
